<!--  -->
<template>
  <div>
    <div class="chsikew">
      <el-tag
        v-if="wechatid"
        style="margin-right:10px"
      >{{ wechatname }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        @click="choosewecaht"
      >选择小程序</el-button>
    </div>
    <div
      class="chsikew"
      style="flex-wrap: wrap;"
    >
      <!-- <el-tag
        v-if="configureid"
        style="margin-right:10px"
      >{{ configurename }}({{ configureid }})</el-tag> -->
      <el-tag
        v-for="tag,index in corp_idsall"
        :key="index"
        style="margin-right:10px;margin-bottom:10px"
        closable
        @close="closechange(index)"
      >
        {{ tag.corp_name }}（{{ tag.corp_id }}）
      </el-tag>
      <el-button
        type="primary"
        size="mini"
        @click="chooseaccount"
      >选择企微</el-button>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        style="margin-left:520px;margin-top:60px"
        @click="sureclick"
      >确 定</el-button>
    </span>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="70%"
    >
      <!-- <chhosewechat ref="chhosewecahtr" @callback="callback" /> -->
      <bandwechat
        ref="chhosewecahtr"
        @callitem="callitem"
        @callwechatrcr="callwechatrcr"
      />
    </el-dialog>
    <el-dialog
      title="选择绑定的企微"
      :visible.sync="dialogVisibleqiwei"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="70%"
    >
      <enterpriseband
        ref="chhoseweqiwei"
        @callbackqiwei="callbackqiwei"
      />
      <!-- <chhosewechatqiwei ref="chhoseweqiwei" @callbackqiwei="callbackqiwei" /> -->
    </el-dialog>
  </div>
</template>

<script>
// import chhosewechat from '../../squaredappletSconfigure/components/chhosewechat.vue'
// import chhosewechatqiwei from './chhosewechatqiwei.vue'
import { spCorplistband } from '@/api/officialaccount.js'
import bandwechat from './bandwechat.vue'
import enterpriseband from './enterpriseband.vue'
export default {
  components: { bandwechat, enterpriseband },
  data() {
    return {
      wechatid: null,
      wechatname: '',
      configureid: null,
      configurename: '',
      dialogVisiblewechat: false,
      dialogVisibleqiwei: false,
      corp_idsall: [],
      fuarr: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    choosewecaht() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.wechatid = item.app_id
      console.log('item', item)
    },
    chooseaccount() {
      this.dialogVisibleqiwei = true
      this.$nextTick(() => {
        this.$refs.chhoseweqiwei.sendr(this.corp_idsall)
      })
    },
    callbackqiwei(arr) {
      this.dialogVisibleqiwei = false
      // this.configureid = item.corp_id
      // this.configurename = item.corp_name
      console.log(arr)
      this.corp_idsall = []
      this.corp_idsall = arr
    },
    async sureclick() {
      if (this.wechatid === null) {
        this.$message.error('请选择小程序')
        return
      }
      if (this.corp_idsall.length === 0) {
        this.$message.error('请选择企微')
        return
      }
      this.fuarr = []
      this.fuarr = this.corp_idsall.map(item => {
        return item.corp_id
      })
      const data = await spCorplistband({
        corp_ids: this.fuarr,
        app_id: this.wechatid
      })
      console.log('data', data)
      this.$emit('updata')
    },
    callitem(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.wechatid = item.app_id
      console.log(item)
    },
    callwechatrcr(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.des_1
      this.wechatid = item.app_id
      console.log(item)
    },
    closechange(index) {
      this.corp_idsall.splice(index, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chsikew {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
@media (max-width: 768px){
  .el-tag{
    font-size:2.5vw;
  }
}
</style>
